<template>
  <div class="logo-slider">
    <div :class="['slider-track', directionClass]" :style="trackStyle">
      <div v-for="(logo, index) in duplicatedLogos" :key="index" class="slide">
        <img :src="logo" alt="Logo de marca" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandSlider",
  props: {
    logos: {
      type: Array,
      required: true,
    },
    direction: {
      type: String,
      default: "left", // 'left' o 'right'
      validator: (value) => ["left", "right"].includes(value),
    },
    speed: {
      type: Number,
      default: 30, // duración en segundos
    },
  },
  computed: {
    duplicatedLogos() {
      return [...this.logos, ...this.logos, ...this.logos, ...this.logos]; // loop infinito
    },
    directionClass() {
      return this.direction === "right" ? "scroll-right" : "scroll-left";
    },
    trackStyle() {
      return {
        animationDuration: `${this.speed}s`,
      };
    },
  },
};
</script>

<style scoped>
.logo-slider {
  overflow: hidden;
  width: 100%;
  height: 170px; /* ⬆️ Más alto */
  background: #fff;
  display: flex;
  align-items: center;
}

.slider-track {
  display: flex;

  white-space: nowrap;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.slide {
  display: inline-block;
  padding: 0 30px; /* un poco más de espacio */
  display: flex;
  justify-content: center;
  align-items: center;
}

.slide img {
  height: auto;
  max-height: 140px; /* Altura máxima */
  max-width: 300px; /* Opcional: para que ninguna sea muy ancha */
  object-fit: contain;
  display: block;
}

/* Animaciones */
.scroll-left {
  animation-name: scroll-left;
}

.scroll-right {
  animation-name: scroll-right;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes scroll-right {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0%);
  }
}

/* ✅ Responsive para pantallas pequeñas */
@media (max-width: 768px) {
  .logo-slider {
    height: 130px;
  }

  .slide {
    padding: 0 20px;
  }

  .slide img {
    max-height: 90px;
    max-width: 130px;
  }
}

@media (max-width: 480px) {
  .logo-slider {
    height: 100px;
  }

  .slide img {
    max-height: 70px;
    max-width: 100px;
  }
}
</style>
